'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _GameScoreCard = require('./GameScoreCard.css');

var _GameScoreCard2 = _interopRequireDefault(_GameScoreCard);

var _ResponsivePNG = require('../ResponsivePNG/ResponsivePNG');

var _ResponsivePNG2 = _interopRequireDefault(_ResponsivePNG);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scoreCardClick = function scoreCardClick(url, trackEvent) {
  if (trackEvent) {
    trackEvent('score_card_click', { destination: url });
  }
  if (url) window.location = url;
};

var formatDate = function formatDate(date) {
  var gameDate = new Date(date);
  var month = gameDate.toLocaleString('en-us', { month: 'short' });
  var day = gameDate.getDate();
  return month + ' ' + day;
};

var formatTime = function formatTime(date, final) {
  var gameDate = new Date(date);
  var time = gameDate.toLocaleString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  });
  return final ? 'Final' : time;
};

var GameScoreCard = function GameScoreCard(props) {
  return _react2.default.createElement(
    'div',
    {
      onClick: function onClick() {
        return scoreCardClick(props.boxscoreUrl, props.trackEvent);
      },
      className: 'jsx-' + _GameScoreCard2.default.__scopedHash + ' ' + 'gameScore'
    },
    _react2.default.createElement(
      'div',
      {
        className: 'jsx-' + _GameScoreCard2.default.__scopedHash + ' ' + 'gameScoreRow'
      },
      _react2.default.createElement(
        'span',
        {
          className: 'jsx-' + _GameScoreCard2.default.__scopedHash + ' ' + 'logoCell'
        },
        props.firstTeam.logoUrl ? _react2.default.createElement(_ResponsivePNG2.default, {
          style: _GameScoreCard.logoCss,
          className: 'logo',
          src: props.firstTeam.logoUrl,
          alt: ''
        }) : _react2.default.createElement('div', {
          className: 'jsx-' + _GameScoreCard2.default.__scopedHash + ' ' + 'logo logo-default'
        })
      ),
      _react2.default.createElement(
        'span',
        {
          className: 'jsx-' + _GameScoreCard2.default.__scopedHash + ' ' + 'teamName'
        },
        props.firstTeam.name
      ),
      props.score && _react2.default.createElement(
        'span',
        {
          className: 'jsx-' + _GameScoreCard2.default.__scopedHash + ' ' + ((props.winner === props.firstTeam.alignment ? 'score bold' : 'score') || '')
        },
        props.firstTeam.alignment === 'home' ? props.score.home : props.score.away
      ),
      props.gameDate && props.eventStatus === 'pre_game' ? _react2.default.createElement(
        'div',
        {
          className: 'jsx-' + _GameScoreCard2.default.__scopedHash + ' ' + 'gameInfo'
        },
        formatTime(props.gameDate.date, props.gameDate.final)
      ) : _react2.default.createElement(
        'div',
        {
          className: 'jsx-' + _GameScoreCard2.default.__scopedHash + ' ' + 'gameInfo'
        },
        props.gameClock.label
      )
    ),
    _react2.default.createElement(
      'div',
      {
        className: 'jsx-' + _GameScoreCard2.default.__scopedHash + ' ' + 'gameScoreRow'
      },
      _react2.default.createElement(
        'span',
        {
          className: 'jsx-' + _GameScoreCard2.default.__scopedHash + ' ' + 'logoCell'
        },
        props.secondTeam.logoUrl ? _react2.default.createElement(_ResponsivePNG2.default, {
          style: _GameScoreCard.logoCss,
          className: 'logo',
          src: props.secondTeam.logoUrl,
          alt: ''
        }) : _react2.default.createElement('div', {
          className: 'jsx-' + _GameScoreCard2.default.__scopedHash + ' ' + 'logo-default'
        })
      ),
      _react2.default.createElement(
        'span',
        {
          className: 'jsx-' + _GameScoreCard2.default.__scopedHash + ' ' + 'teamName'
        },
        props.secondTeam.name
      ),
      props.score && _react2.default.createElement(
        'span',
        {
          className: 'jsx-' + _GameScoreCard2.default.__scopedHash + ' ' + ((props.winner === props.secondTeam.alignment ? 'score bold' : 'score') || '')
        },
        props.secondTeam.alignment === 'home' ? props.score.home : props.score.away
      ),
      props.gameDate && props.eventStatus !== 'in_progress' && _react2.default.createElement(
        'div',
        {
          className: 'jsx-' + _GameScoreCard2.default.__scopedHash + ' ' + 'gameInfo dark'
        },
        formatDate(props.gameDate.date)
      ),
      props.gameClock && props.eventStatus === 'in_progress' && _react2.default.createElement(
        'div',
        {
          className: 'jsx-' + _GameScoreCard2.default.__scopedHash + ' ' + 'gameInfo'
        },
        props.gameClock.period
      )
    ),
    _react2.default.createElement(_style2.default, {
      styleId: _GameScoreCard2.default.__scopedHash,
      css: _GameScoreCard2.default.__scoped
    })
  );
};

var teamShape = _propTypes2.default.shape({
  logoUrl: _propTypes2.default.string,
  name: _propTypes2.default.string,
  alignment: _propTypes2.default.string
});

GameScoreCard.propTypes = {
  eventStatus: _propTypes2.default.string.isRequired,
  firstTeam: teamShape.isRequired,
  boxscoreUrl: _propTypes2.default.string,
  gameClock: _propTypes2.default.shape({
    label: _propTypes2.default.string,
    period: _propTypes2.default.string
  }),
  gameDate: _propTypes2.default.shape({
    date: _propTypes2.default.string,
    final: _propTypes2.default.bool
  }),
  secondTeam: teamShape.isRequired,
  score: _propTypes2.default.shape({
    home: _propTypes2.default.string,
    away: _propTypes2.default.string
  }),
  trackEvent: _propTypes2.default.func,
  winner: _propTypes2.default.oneOf(['home', 'away'])
};

GameScoreCard.defaultProps = {
  gameClock: null,
  gameDate: null,
  score: null,
  trackEvent: null,
  winner: null,
  boxscoreUrl: null
};

exports.default = GameScoreCard;